(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compare-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('compare-modal')) {
    class CompareModal extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.querySelectorAll('.js-compare-modal-radio').forEach((radio) => {
          radio.addEventListener('change', (e) => {
            this.querySelectorAll('.js-block-container').forEach((container) => {
              if (container.dataset.category === e.target.value) {
                container.classList.add('is-active')
              } else {
                container.classList.remove('is-active')
              }
            })
          })
        })
      }
    }
    customElements.define('compare-modal', CompareModal)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets-mobile"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('facets-mobile')) {
    class FacetsMobile extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.addEventListener('click', this.openFacets.bind(this))
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.openFacets.bind(this))
      }

      openFacets(event) {
        if (!event.target.dataset.filterButton) return
        const filterName = event.target.dataset.filterButton
        const filterFound = document.querySelector(
          `#FacetFiltersFormMobile details[data-filter-label="${filterName}"] summary`,
        )
        if (!filterFound) return
        filterFound.click()
        setTimeout(() => {
          document.querySelector('menu-drawer .mobile-facets__open-label').click()
        }, 200)
      }
    }
    customElements.define('facets-mobile', FacetsMobile)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-nav-type-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobile-nav-type-selector')) {
    class MobileNavTypeSelector extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.section = this.closest('.shopify-section')
        this.contentTargetSelector = this.dataset.contentTargetSelector
        this.contentTarget = this.section.querySelector(this.contentTargetSelector)
        this.addEventListener('change', this.onChange.bind(this))
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange.bind(this))
      }

      onChange(e) {
        this.contentTarget.setAttribute('data-menu-handle', e.target.value)
        if (typeof this.contentTarget.switchMenu === 'function') {
          this.contentTarget.switchMenu(e.target.value)
        } else {
          this.contentTarget.fetchMenu()
        }
      }
    }
    customElements.define('mobile-nav-type-selector', MobileNavTypeSelector)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-product-widget"] && !Shopify.designMode) return;
  try {
    function fetchRivoFavorites() {
    window.favoriteProductsIds = []
    const checkInterval = setInterval(() => {
      if (typeof RivoProfileAlpine !== 'undefined' && RivoProfileAlpine !== null) {
        clearInterval(checkInterval)
        setInterval(() => {
          document
            .querySelectorAll('rivo-favorite-button')
            .forEach((item) => (item.dataset.rivoFavoriteReady = true))
        }, 150)
      }
    }, 100)
  }

  document.addEventListener('DOMContentLoaded', () => {
    fetchRivoFavorites()
  })
  } catch(e) { console.error(e); }
})();

})();
